"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contact_1 = require("./types/contact");

exports.Contact = contact_1.Contact;

var collection_1 = require("./types/collection");

exports.Collection = collection_1.Collection;